import React, { useState } from 'react';
import { Body } from '../../shared/styled-components/styled_text';
import { Tooltip, TooltipContent, TooltipTrigger } from './Tooltip';

interface Props extends Omit<React.HTMLProps<HTMLDivElement>, 'onClick'> {
  data: string;
  tooltip: string;
  propagate?: boolean;
  children: React.ReactNode;
}

export const Clipboard: React.FC<Props> = ({ data, tooltip, propagate, children, ...rest }) => {
  const [open, setOpen] = useState(false);
  const handleCopy = (e: React.MouseEvent) => {
    if (!propagate) e.stopPropagation();
    navigator.clipboard.writeText(data);
    setOpen(true);
    setTimeout(() => setOpen(false), 2500);
  };

  return (
    <Tooltip open={open} onOpenChange={setOpen}>
      <TooltipContent>
        <Body size={'s'}>{tooltip}</Body>
      </TooltipContent>
      <TooltipTrigger
        onClick={e => {
          setOpen(p => !p);
          handleCopy(e);
        }}
      >
        <div {...rest}>{children}</div>
      </TooltipTrigger>
    </Tooltip>
  );
};
